import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Box, Typography, CircularProgress } from '@mui/material';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReportScheduleService from '../../services/report-schedule.service';

// Página PÚBLICA do link "Não quero mais receber" dos e-mails de relatório agendado.
// Sem login: o token do destinatário (UUID secreto) identifica o descadastro.
class ReportUnsubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, ok: false, name: '' };
  }

  componentDidMount() {
    const token = this.props.match && this.props.match.params ? this.props.match.params.token : '';
    ReportScheduleService.unsubscribe(token)
      .then(r => this.setState({ loading: false, ok: true, name: (r.data && r.data.data && r.data.data.name) || '' }))
      .catch(() => this.setState({ loading: false, ok: false }));
  }

  render() {
    const { intl } = this.props;
    const { loading, ok, name } = this.state;
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', p: 2 }}>
        <Box sx={{ maxWidth: 460, width: '100%', backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '12px', p: 4, textAlign: 'center' }}>
          {loading ? <CircularProgress color="secondary" /> : (
            <>
              <Box sx={{ width: 72, height: 72, borderRadius: '50%', backgroundColor: ok ? '#eef7e3' : '#fdecea', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                {ok ? <MarkEmailReadOutlinedIcon sx={{ fontSize: 36, color: '#5b9b1e' }} /> : <ErrorOutlineIcon sx={{ fontSize: 36, color: '#c62828' }} />}
              </Box>
              <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#333', mb: 1 }}>
                {intl.formatMessage({ id: ok ? 'report.schedule.unsubscribe.ok.title' : 'report.schedule.unsubscribe.fail.title' })}
              </Typography>
              <Typography sx={{ fontSize: 14, color: '#777' }}>
                {ok
                  ? intl.formatMessage({ id: 'report.schedule.unsubscribe.ok.desc' }, { name })
                  : intl.formatMessage({ id: 'report.schedule.unsubscribe.fail.desc' })}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    );
  }
}

export default injectIntl(ReportUnsubscribe);
